import React, {
  createContext,
  useContext,
  useState,
  useCallback,
  useMemo,
} from 'react';
import { AddToCartModal } from './AddToCartModal';

const AddToCartModalContext = createContext(null);

export const useAddToCartModal = () => {
  const context = useContext(AddToCartModalContext);
  if (!context) {
    throw new Error(
      'useAddToCartModal must be used within AddToCartModalProvider'
    );
  }
  return context;
};

export const AddToCartModalProvider = ({ children }) => {
  const [product, setProduct] = useState(null);
  const [isOpen, setIsOpen] = useState(false);

  const openModal = useCallback((product) => {
    setProduct(product);
    setIsOpen(true);
  }, []);

  const closeModal = useCallback(() => {
    setIsOpen(false);
    setProduct(null);
  }, []);

  // Stable value so opening/closing the modal doesn't re-render every card
  const value = useMemo(() => ({ openModal }), [openModal]);

  return (
    <AddToCartModalContext.Provider value={value}>
      {children}
      <AddToCartModal isOpen={isOpen} onClose={closeModal} product={product} />
    </AddToCartModalContext.Provider>
  );
};
